import React from 'react'
import { Link,useNavigate } from 'react-router-dom'
import LogoWhite from '../../assets/images/logo-white.png'
import { StateUseContext } from '../../context/UserDetailContext'

const Header = () => {
  const navigate = useNavigate();
  const {userDetail,setUserDetail} = StateUseContext();

  const logoutHandler = () => {
    sessionStorage.removeItem('token');
    setUserDetail([])
    navigate('login');
  }
  return (
    <header>
    <nav className="navbar navbar-expand-lg bg-primary">
        <div className="container">
          <Link className="navbar-brand" to={'/student/dashboard'}>
            <img src={LogoWhite} alt="Logo" className="img-fluid"/>
          </Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>


          <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
            <ul  className="navbar-nav d-block d-lg-none ms-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="dropdown-item" to="dashboard">Dashboard</Link>
                </li> 
                <li className="nav-item">
                <Link className="dropdown-item" to={`my-transactions`}>Payments</Link>
                </li> 
                <li className="nav-item">
                <Link className="dropdown-item" to={`change-password/${userDetail?.id}`}>Change Password</Link>
                </li> 

                <li className="nav-item">
                <Link className="dropdown-item" to="/login" onClick={logoutHandler}>Logout</Link>
                </li> 
            </ul>

            <ul className="navbar-nav ms-auto mb-2 mb-lg-0  d-none d-lg-block">
              <li className="nav-item dropdown">
                <Link className="nav-link dropdown-toggle" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  Welcome, {userDetail?.name}
                </Link>
                <ul className="dropdown-menu">
                  <li><Link className="dropdown-item" to="dashboard">Dashboard</Link></li>
                  <li><Link className="dropdown-item" to={`my-transactions`}>Payments</Link></li>
                  <li><Link className="dropdown-item" to={`change-password/${userDetail?.id}`}>Change Password</Link></li>
                  <li><Link className="dropdown-item" to="/login" onClick={logoutHandler}>Logout</Link></li>
                </ul>
              </li>
            </ul>

          </div>
          
        </div>
      </nav>
    </header>
  )
}

export default Header